<div class="row mt-3 mb-5 mx-3 mx-md-0">
  <div class="col-12 col-md-10 offset-md-1 text-center">

    <mat-icon class="color-blue-cat icon-material">search_off</mat-icon>
    <h1 class="color-blue-cat">Página no encontrada</h1>
    <p>Es posible que la página que buscas haya sido eliminada, haya expirado o la dirección no existe.</p>

    <button mat-raised-button color="primary" [routerLink]="['/inicio']">Ir al Inicio</button>

  </div>
</div>
